import React from "react";
import "./ForgotPasswordContainer.css";
import "utilities/css/simpleForm.css";
import {sendResetPasswordEmail}  from "utilities/js/callouts/CalloutFactory";
import InputBox from "../../components/reusable/InputBox";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import BracksetHeader from "components/reusable/BracksetHeader";
import BracksetFooter from "components/reusable/BracksetFooter";
import Constants from "utilities/js/Constants";


const loadingIcon = Constants.ICON_LOADING;

class ForgotPasswordContainer extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            username: '',
            email: '',
            isLoading: true,
            isError: false,
            errorMessage: "There was a problem resetting your password",
            inputError: null,
            emailSent: false
        };
        
        this.displayContent = this.displayContent.bind(this);
        this.initiatePasswordReset = this.initiatePasswordReset.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.navigateToLandingPage = this.navigateToLandingPage(this);
        
    }
    
    componentDidMount(){
        this.setState({isLoading: false})
    }
    
    navigateToLandingPage(){
        navigateToLandingPage({routerNav: this.props.navigate})
    }
    
    setEmail(event){
        this.setState({email: event.target.value});
    }

    
    initiatePasswordReset(){
        if(this.areInputsValid()){
            this.setState({isLoading: true});
            sendResetPasswordEmail(this.state.email).then(response => {
                this.setState({isError: false, emailSent: true});
            }).catch(error => {
                if(error.code){
                    this.setState({errorMessage: error.message, isError: true})
                }else{
                    this.setState({isError: true});
                }
            }).finally(() => {
                this.setState({isLoading: false});
            });
        }
    }
    


    areInputsValid(){
        let errorDisplay;
        if(!this.state.email || !this.state.email.includes('@') || !this.state.email.includes('.')){
            errorDisplay = 'Must input a valid email address';
        }
        if(errorDisplay){
            this.setState({inputError: errorDisplay});
            // this.registerInputContainerRef.current.scrollTop = 0;
            return false;
        }

        return true;
    }
    
    displayContent(){
        if(this.state.emailSent){
            return (
                <>
                    <div>
                        <div className="verify-email-header">Success</div><div className="verify-email-success">An email with instructions on how to reset your password was sent to <b>{this.state.email}</b>.  Click <a href="/">here</a> to navigate to the home page</div>
                    </div>
                </>
            )
        }else if(this.state.isError){
            return (<>
                <div>
                <div className="verify-email-header">Error</div>
                <div className="verify-email-error">{this.state.errorMessage}<div>Click <a href="/">here</a> to navigate to the home page</div></div>
                </div>
            </>)
        }else{
            return (
            <>
                <div>
                    <div className="simple-form-header-container">
                        <div className="simple-form-header">Forgot Password</div>
                        <div className="simple-form-sub-header">Input the email associated to the account for which you want to reset the password for</div>
                        <div className="simple-form-error">{this.state.inputError}</div>
                    </div>
                    <div className="input-container">
                        <div className="simple-form-input-label">Email</div>
                        <InputBox uniqueKey="email" name='loginEmail' placeholder='email' class='login-styled-input' value={this.state.email} valueChangedCallback={this.setEmail}></InputBox>
                    </div>
                    <div className="simple-form-button-container">
                        <button label='simple-form-button' className='simple-form-button' onClick={this.initiatePasswordReset}>Send Reset Password Email</button>
                    </div>
                </div>
                <div className="simple-form-footer">
                    Not interested in resetting your password? <button className="login-toggle-button" onClick={this.navigateToLandingPage}>Return Home</button>
                </div>
            </>
            )
        }
    }
            
    render(){
        let content = (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        if(!this.state.isLoading){
            content = (<>{this.displayContent()}</>);
        }
        
        return (
            
            <>
                <div className="brackset-container">
                    
                    <BracksetHeader hideSearch="true"></BracksetHeader>
                        <div className="simple-form">
                            {content}
                        </div>
                    <BracksetFooter></BracksetFooter>
                </div>
            </>
        )
            
    }
}

export default NavigatorWrapper(ForgotPasswordContainer);
    